import React from 'react';

export const Logo = () => {
  return (
      <div style={{height: 40, width: 40, backgroundColor: 'red', borderRadius: 20}} />
  )
}